import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetAutocompleteSuggestionsQueryVariables = Types.Exact<{
  params: Types.GetAutocompleteSuggestionsInput;
}>;


export type GetAutocompleteSuggestionsQuery = { getAutocompleteSuggestions?: { suggestions: Array<string> } | null };


export const GetAutocompleteSuggestionsDocument = /*#__PURE__*/ gql`
    query GetAutocompleteSuggestions($params: GetAutocompleteSuggestionsInput!) {
  getAutocompleteSuggestions(params: $params) {
    suggestions
  }
}
    `;

export function useGetAutocompleteSuggestionsQuery(options: Omit<Urql.UseQueryArgs<GetAutocompleteSuggestionsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAutocompleteSuggestionsQuery, GetAutocompleteSuggestionsQueryVariables>({ query: GetAutocompleteSuggestionsDocument, ...options });
};